// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { userSetupHeaderStyles } from "@steiner/Overrides/Widgets/UserSetup/UserSetupHeader";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

userSetupHeaderStyles.container = {
    css: css`
        padding-bottom: 15px;
    `,
};

userSetupHeaderStyles.actionsGridItem = {
    width: [2, 2, 4, 5, 5],
    css: css`
        justify-content: flex-end;
        padding-top: 21px;
    `,
};

userSetupHeaderStyles.cancelButton = {
    variant: "secondary",
    css: css`
        margin-right: 10px;
    `,
};

userSetupHeaderStyles.overflowMenu = {
    cssOverrides: {
        wrapper: css`
            display: flex;
            align-items: flex-start;
            margin-left: 10px;
        `,
    },
};

userSetupHeaderStyles.overflowMenuSmallClickables = {
    css: css`
        ${xScreen("gt", "md")} {
            &&& {
                display: none;
            }
        }
    `,
};
